/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

 Essentals

 */

import $ from 'jquery';


/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

 NPM Packages

 */

import 'lazysizes/plugins/print/ls.print'; // needs to be BEFORE the main script
import 'lazysizes';
import * as Sentry from '@sentry/browser';

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

 allink CORE (NPM package)

 ===

 These modules provide core functionality.

 Note: Should you need a customzied project specific version of one of
 the following modules:

 Head over to the 'allink-core-static' repo, comment out the module below,
 download the latest version and place it in the ./modules folder.

 */

import './modules/form-modal';
import './modules/ajax-load-items';
import './modules/form-validation';

import 'allink-core-static/js/modules/bootstrap-select';
import 'allink-core-static/js/modules/btn-ajax-loader';
import 'allink-core-static/js/modules/contact-form';
import 'allink-core-static/js/modules/datepicker';
import 'allink-core-static/js/modules/djangocms-tweaks';
import 'allink-core-static/js/modules/feature-detection';
import 'allink-core-static/js/modules/form';
// import 'allink-core-static/js/modules/form-modal';
import 'allink-core-static/js/modules/form-validation';
import 'allink-core-static/js/modules/full-height';
import 'allink-core-static/js/modules/image-modal';
import 'allink-core-static/js/modules/masonry';
import 'allink-core-static/js/modules/seo';
import 'allink-core-static/js/modules/site-overlay';
import 'allink-core-static/js/modules/softpage';
import 'allink-core-static/js/modules/table';
import 'allink-core-static/js/modules/tingle';
// import 'allink-core-static/js/modules/video';
import 'allink-core-static/js/modules/viewport-dimensions';
// import 'allink-core-static/js/modules/infobox';

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

 Custom Scripts

 */


import './modules/ajax-form';
import './modules/header';
import './modules/map';
import './modules/navigation';
import './modules/onscreen';
import './modules/parallax';
import './modules/swiper';
import './modules/to-the-top';
import './modules/topics';
import './modules/grid-random';
import './modules/campuskmu';
import './modules/info-modal';
import './modules/events';
import './modules/information-tile';
import './modules/podcast';
import './modules/joinus';
// hotfix Math-round in line :128 to solve smooth-scroll issue
import './modules/smooth-scroll';
import './modules/table_expand';
import './modules/accordion';
import './modules/video';
import './modules/teaser-modal';
import {OffCanvas} from "./modules/offCanvas";


$(document).ready(function() {


    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

     Newsletter Form Toggle

     Update: Not in use anymore

     */

    // $('[data-toggle-newsletter-form]').on('click', function (e) {
    //     // init
    //     e.preventDefault();
    //     var $trigger = $(this);
    //     var $newsletter_container = $('#mailchimp-form-container');
    //     var opened_class = 'opened';
    //     // check state:
    //     // about to be visible
    //     if ($trigger.hasClass(opened_class)) {
    //         $trigger.removeClass(opened_class);
    //     }
    //     // about to be hidden
    //     else {
    //         $trigger.addClass(opened_class);
    //         $newsletter_container.focus();
    //     }
    //     // toggle
    //     $newsletter_container.toggle(150);
    // })

    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

     Initialize CMS-Plugins after Ajax-Request

     */

    const offCanvasContainer = $('[data-offcanvas]')

    if (offCanvasContainer) {
        new OffCanvas(offCanvasContainer);
    }

    if (typeof CMS !== 'undefined') {
        $(window).on('ajaxLoadItems:success', function (event) {
            console.log('init');
            CMS.Plugin._initializeTree();

        });
    }

    // Sentry.init({
    //   dsn: 'https://96809a472df942eca6a10e2e3838a6d6@sentry.io/141587',
    // });

});




// WEBPACK FOOTER //
// ./static/js/app.js